//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import { listChannelFeaturedElements } from '@/api/channels.js';

export default {
  name: 'FreeProducts',
  mixins: [productEventsMixin],
  props: {
    products: {
      type: Array,
    },
    mediaType: String,
    curation: {
      type: Object,
    },
  },
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
  },
  data() {
    return {
      isLoading: false,
      elements: [],
      popularElements: [],
      count: 16,
      perPage: 16,
    };
  },
  mounted() {
    if (this.isAudio) {
      this.count = 6;
      this.perPage = 6;
    }
    this.popularElementsList();
  },
  computed: {
    isAudio() {
      return isProductType('audio', this.mediaType);
    },
    viewAllUrl() {
      return _.get(this.curation, 'html.url');
    },
  },
  methods: {
    popularElementsList() {
      this.isLoading = true;
      listChannelFeaturedElements(this.mediaType, {
        perPage: this.perPage,
        free: 0,
      })
        .then((response) => {
          this.popularElements = response.data.data;
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
